import React from 'react';
import { Box, Typography } from '@mui/material';
import { t } from '../../../../utils/translate';

/**
 * The third render state of a chart, alongside LoadingState and ErrorState in this folder.
 * It exists because an analytics endpoint answering 200 with no rows is ordinary -- a new
 * tenant, a quiet week, a filter that matches nothing -- and ApexCharts throws rather than
 * drawing nothing (SHER-832). Four other components in charts/ mount the same library and
 * will need this the moment they get the same guard.
 *
 * SHER-854 added the second line. Now that the dashboard opens on a period of its own
 * choosing rather than on a blank filter, "no rows" is an answer the reader did not ask
 * for and cannot act on unless the state names the control that changes it.
 */
const EmptyState = ({ height = 400 }: { height?: number }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height }}>
    <Typography variant="body2" color="text.secondary">
      {t('hospital.analytics.no_data')}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {t('hospital.analytics.no_data_hint')}
    </Typography>
  </Box>
);

export default EmptyState;
